import {
	UPDATE_FILTER_FIELD_BEING_MANUALLY_EDITED_ACTION,
	UPDATE_OPTION_ACTION,
	TOGGLE_FEATURE_TOUR_ACTION,
} from '../Actions/uiActions'

const DEFAULT_STATE = {
	opt: null,
	filterFieldBeingManuallyEdited: '',
	featureTourIsOpen: false,
}

export default (state = DEFAULT_STATE, action) => {
	const { opt, fieldName, featureTourIsOpen } = action
	switch (action.type) {
		case UPDATE_OPTION_ACTION:
			return {
				...state,
				opt,
			}
		case UPDATE_FILTER_FIELD_BEING_MANUALLY_EDITED_ACTION:
			return {
				...state,
				filterFieldBeingManuallyEdited: fieldName || ''
			}
		case TOGGLE_FEATURE_TOUR_ACTION:
			return {
				...state,
				featureTourIsOpen,
			}
		default:
			return state
	}
}
